import AuthService from './AuthService';
import AppSettingsService from './AppSettingsService';
import AxiosService from './AxiosService';
import SessionStorageService from './SessionStorageService';
import CookieService from './CookieService';

const configureServices = async () => {
    const cookies = new CookieService();
    const session = new SessionStorageService();
    const appSettings = new AppSettingsService();
    const auth = new AuthService(appSettings);
    const axios = new AxiosService(
        appSettings.GetWebApiBaseUri(),
        auth,
        session
    );

    return { appSettings, auth, axios, session, cookies };
};

export default configureServices;
